<template>
    <div class="section-coupon6">
        <div class="text-descrition">{{title}}</div>
        <div class="text-campaign">{{description}}</div>
        <div class="box-icon-star">
            <div class="icon-star" v-for="(v,k) in allItem" :key="k">
                <img class="img-fluid" src="@/assets/icon/mission_icon_inactive.svg"
                    v-if="(k+1) > productCollect"/>
                <img class="img-fluid" src="@/assets/icon/mission_icon_active.svg" 
                    v-if="(k+1) <= productCollect"/>
            </div>
        </div>
        <div class="text-collect">{{textCollect}}</div>
        <div class="btn-more-collect" @click="clickToCollect()" v-if="productCollect < allItem">
            <div class="btn-txt">
                {{lbl.btn}}
            </div>
        </div>
        <div class="btn-more-collect" @click="clickToHistory()" v-else>
            <div class="btn-txt">
                {{lbl.btn_success}}
            </div>
        </div>
    </div>
</template>
<script>
import CacheHelper from "@/helper/CacheHelper.js";
export default {
    name: 'Coupon6',
    props:{
        lbl: Object,
        modalController: Object,
        isLoading: Boolean,
        badgeDetail: Object
    },
    data: function () {
        return {
            title: '',
            description: '',
            textCollect: '',

            allItem: 0,
            productCollect: null,
        };
    },
    created: function(){
        this.initialMission();
    },
    methods:{
        initialMission: function(){
            
            this.showLoading();

            if(!this.badgeDetail) return;

            this.hideLoading();

            var mission = this.badgeDetail;
            console.log('mission', mission)

            var info = null;
            if(mission.CustomInfo){
                info = JSON.parse(mission.CustomInfo);
                this.title = info.l_title;
                this.description = info.d_description;
            }

            this.allItem = mission.Missions[0].Value;
            this.productCollect = mission.Missions[0].Current;

            this.textCollect = `สะสมไปแล้ว ${this.productCollect}/${this.allItem}`;
        },
        clickToCollect: function(){
            var cache = new CacheHelper('session');
            cache.setCache('BDMScan', true);

            this.$router.push('/point');
        },
        clickToHistory: function(){
            this.$router.push('/history/burn');
        },
        //utilities
        showLoading: function () {
            if (this.isLoading) return true;
            this.toggleLoading(true);

            return false;
        },
        hideLoading: function () {
            this.toggleLoading(false);
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
@import '@/style/input/BaseButton.scss';

.section-coupon6{
    text-align: center;

    .text-descrition{
        color: $bright-gray;
        padding: 40px 0 20px;
    }

    .text-campaign{
        color: $dark-blue;
        font-family: $medium;
        font-size: 1.18rem;
    }

    .box-icon-star{
        @extend %display-flex;
        width: 85%;
        margin: auto;
        padding: 100px 0 80px;

        .icon-star{
            flex: 0 0 calc(100% / 3);
            width: calc(100% / 3);
        }
    }

    .text-collect{
        color: $pink;
        font-family: $medium;
        font-size: 1.375rem;
    }

    .btn-more-collect{
        @include btn-wrapper();
        width: 90%;
        margin: 60px auto 40px;

        &.disabled{
            opacity: 1;
            background-color: rgba($border-gray, 0.17);
            box-shadow: $box-shadow;

            .btn-txt{
                color: $label-gray;
            }
        }
    }
}
</style>